/**
 * Created by idea on 20/03/2017.
 */
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Router} from '@angular/router';
import {ApiService} from './Api.service'

@Injectable()
export class CategoryService extends ApiService{
    constructor(http:Http,router: Router){
        super(http,router);
        this.setEndPoint('/categories')
    }

}


// WEBPACK FOOTER //
// /app/src/app/common/services/Category.service.ts